import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import times from 'lodash/times';

var GlobalTitle = function GlobalTitle() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalTitle.vue');
};

var ProductItem = function ProductItem() {
  return import(
  /* webpackChunkName: "product" */
  '~/components/library/Product/ProductItem.vue');
};

export default {
  name: 'HomeProducts',
  components: {
    GlobalTitle: GlobalTitle,
    ProductItem: ProductItem
  },
  props: {
    payload: {
      type: Object,
      required: true
    },
    catalog: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload: function currentPayload() {
      var _this = this;

      var _ref;

      return {
        title: ((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? (_ref = _ref.title) != null ? _ref[0] : _ref : _ref : _ref) || {},
        tracking: times(this.payload.items.length, Number).map(function (i) {
          return {
            fn: 'product_list_click',
            data: {
              product_id: _this.payload.items[i].reference || '',
              position: "".concat(i + 1)
            }
          };
        })
      };
    }
  },
  mounted: function mounted() {
    window.tc_vars.list_products = this.catalog.products.map(function (e, i) {
      return {
        list_product_id: e.reference,
        list_product_position: i + 1
      };
    });
  }
};